import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import Cookie from 'js-cookie';
import account from './modules/account';
import registration from './modules/registration';
import ageGroup from './modules/ageGroup';
import auth from './modules/auth';
import alerts from './modules/alerts';
import signUps from './modules/signups';
import accountAge from './modules/accountAge';
import session from './modules/session';
import location from './modules/location';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        account,
        registration,
        ageGroup,
        auth,
        alerts,
        signUps,
        accountAge,
        session,
        location
    },
    plugins: [
        createPersistedState({
            paths: ['auth.isLoggedIn', 'auth.user'],
            getState: (key) => Cookie.getJSON(key),
            setState: (key, state) => Cookie.set(key, state, {
                expires: 30,
                secure: false
            })
        }),
       /* createPersistedState({
            paths: ['ageGroup.ageGroups']
        })*/
    ],
    state: {
        http_error: null,
        date: null
    },
    getters: {
        http_error: (state) => {
            return state.http_error
        },
        date: (state) => {
            return state.date
        }
    },
    mutations: {
        set_http_error(state, error) {
          state.http_error = error
        },
        set_date: (state, date) => {
            state.date = date
        }
    }
})

export default store;